import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

export default function DocumentCallAction({ label, icon, variant = 'warning', disabled, onClick }) {
  return <OverlayTrigger placement="top" overlay={<Tooltip>{label}</Tooltip>}>
    <span className="portal-document-call-action-wrap" tabIndex={disabled ? 0 : undefined} aria-label={disabled ? label : undefined}>
      <Button type="button" variant={variant} className="portal-document-call-action hidethis" aria-label={label} disabled={disabled} onClick={onClick}>{icon}</Button>
    </span>
  </OverlayTrigger>;
}
